// extracted by mini-css-extract-plugin
module.exports = {"questionArea":"Assessment_questionArea__xsd_a","sectionHeading":"Assessment_sectionHeading__zU_8t","BasicDetailsEdit":"Assessment_BasicDetailsEdit__O8tWy"};